import React from 'react';
import { TIconProps } from 'pages/ExperienceCanvas/assets/types';

function ProcessingSpinnerIcon({ fill = '#3f1887', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <circle cx="8" cy="8" r="5.4" stroke="#cdd0d7" strokeWidth="1.6" fill="none" />
      <path
        d="M8 2.6 A5.4 5.4 0 0 1 13.4 8"
        stroke={fill}
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

export default ProcessingSpinnerIcon;
